import { useEffect } from 'react';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import PopularSection from './components/PopularSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫屋',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '韩漫屋—免费韩国漫画在线阅读平台，下拉式观看模式，高清画质大全，每日更新热门韩漫作品。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: '/category?search={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO
        title="韩国漫画免费_在线观看下拉式韩漫_高清韩漫大全-韩漫屋"
        description="在韩漫屋享受全免费韩漫阅读，下拉式观看模式搭配高清画质大全，内容每日更新，让您轻松畅读热门作品。韩漫屋提供恋爱、奇幻、动作、悬疑等多种分类韩国漫画。"
        keywords="免费阅读,下拉式韩漫,高清大全,韩漫屋,在线观看,韩国漫画"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20homepage%20banner%20warm%20orange%20coral%20tones%20minimalist%20elegant%20design%20digital%20art&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={homeSchema}
      />
      <Hero />
      <CategoryNav />
      <PopularSection />
      <LatestSection />

      <section className="py-12 md:py-16 bg-primary-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            随时随地，畅读韩漫
          </h2>
          <p className="text-white/80 mb-8 text-sm md:text-base max-w-2xl mx-auto">
            韩漫屋支持下拉式阅读模式，流畅的阅读体验配合高清画质，让您沉浸式享受韩国漫画的精彩世界。
            无需注册，完全免费，每日更新热门韩漫作品。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-white">
              <i className="ri-smartphone-line text-2xl"></i>
              <span className="text-sm whitespace-nowrap">下拉式阅读</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <i className="ri-hd-line text-2xl"></i>
              <span className="text-sm whitespace-nowrap">高清画质</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <i className="ri-refresh-line text-2xl"></i>
              <span className="text-sm whitespace-nowrap">每日更新</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <i className="ri-shield-check-line text-2xl"></i>
              <span className="text-sm whitespace-nowrap">完全免费</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}